module.exports = __webpack_public_path__ + "ios_app_store.2928664f.svg";